import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=5d8f08be"
import script from "./ResultPage.vue?vue&type=script&lang=ts"
export * from "./ResultPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports